import { useState, useEffect } from "react";
import Menu from "../../../components/menu";
import HeaderMobile from "../../../components/header/index_mobile";
import HeaderDesktop from "../../../components/header/index_desktop";
import GraficoComponent from "../../../components/charts/index";
import InfoHomeComponent1 from "../../../components/infohome-saldo/1";
import InfoHomeComponentDadosFinanceiro from "../../../components/dados_financeiro/1";
import ComponentLoading from "../../../components/loading/Index";
import linhaimg from "../../../assets/linha/linem.png";
import ConfigRedirection from "../../../routes/redirection/ConfigRedirection";
import ComponentFooter from "../../../components/footer/Index";
import useMobileResolution from "../../../hooks/useMobileResolution";

function MobileView() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="flex h-screen">
      {/* Menu lateral */}
      <nav
        className={`bg-gradient-to-b mt-10 from-[#f2f2f2] to-[#fcfcfd] border border-gray-200 text-white py-4 w-full md:w-64 fixed inset-y-0 left-0 z-10 ${
          isMenuOpen ? "block" : "hidden"
        } md:block`}
      >
        <Menu />
      </nav>

      {/* Botão do Menu (aparece apenas em telas pequenas) */}
      <button
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        className="md:hidden fixed w-full bg-[#e6e1db] text-slate-500 border border-slate-400 p-5 z-20"
      >
        {isMenuOpen ? "Fechar Menu" : "Abrir Menu"}
      </button>

      {/* Conteúdo do Dashboard */}
      <div className="w-full mt-10 bg-gradient-to-b from-[#f2f2f2] to-[#fcfcfd] border border-gray-200">
        <div className="w-full bg-gradient-to-r mb-10 from-[#f2f2f2] to-[#fcfcfd]">
          <HeaderMobile />
        </div>

        <div className="w-full bg-gradient-to-r from-[#f2f2f2] to-[#fcfcfd]">
          <InfoHomeComponentDadosFinanceiro />
        </div>

        <div className="w-full bg-gradient-to-r from-[#f2f2f2] to-[#fcfcfd]">
          <InfoHomeComponent1 />
        </div>

        <div className="w-full bg-gradient-to-r from-[#f2f2f2] to-[#fcfcfd]">
          <GraficoComponent />
        </div>
      </div>
    </div>
  );
}

function DesktopView() {
  return (
    <div className="flex flex-col h-screen">
      <div className="flex flex-grow">
        {/* Menu lateral renderizado só se deviceType for "desktop" */}

        <div className="w-64 bg-gradient-to-b shadow-lg from-[#f2f2f2] to-[#fcfcfd] border border-gray-200">
          <Menu />
        </div>

        {/* Conteúdo principal */}
        <div className="w-full md:flex-1 bg-gradient-to-r from-[#f2f2f2] to-[#f2f2f2]">
          <div className="w-full bg-gradient-to-r from-[#f2f2f2] to-[#fcfcfd]">
            <HeaderDesktop />
          </div>

          <div className="flex flex-nowrap justify-center w-full overflow-hidden">
            {[...Array(20)].map((_, index) => (
              <img
                key={index}
                src={linhaimg}
                alt="Linha Versace"
                className="w-28 h-auto opacity-40"
              />
            ))}
          </div>

          <div className="p-10 w-full bg-[#baa78e] bg-opacity-10">
            <InfoHomeComponentDadosFinanceiro />
          </div>

          <div className="p-10 w-full bg-[#baa78e] bg-opacity-10">
            <InfoHomeComponent1 />
          </div>

          <div className="flex flex-nowrap justify-center w-full overflow-hidden">
            {[...Array(20)].map((_, index) => (
              <img
                key={index}
                src={linhaimg}
                alt="Linha Versace"
                className="w-28 h-auto opacity-40"
              />
            ))}
          </div>

          <div className="p-10 w-full">
            <GraficoComponent />
          </div>
        </div>
      </div>

      {/* Rodapé */}
      <ComponentFooter />
    </div>
  );
}

function Index() {
  const [configRendered, setConfigRendered] = useState(false);
  const deviceType = useMobileResolution();

  useEffect(() => {
    setTimeout(() => setConfigRendered(true), 2000);
  }, []);

  return (
    <div className="h-screen bg-[#fcf3e8]">
      {!configRendered && <ComponentLoading />}

      {configRendered && (
        <>
          <ConfigRedirection />
          {deviceType === "mobile" ? (
            <MobileView />
          ) : (
            <DesktopView deviceType={deviceType} />
          )}
        </>
      )}
    </div>
  );
}

export default Index;
